<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="login-form">
      <el-form-item prop="mobile">
        <el-input
          placeholder="请输入手机号"
          v-model="ruleForm.mobile"
          :maxlength="11"
          @keyup.enter="submitForm('ruleForm')"
        ></el-input>
      </el-form-item>
      <el-form-item prop="passwd">
        <el-input
          placeholder="请输入密码"
          v-model="ruleForm.passwd"
          show-password
          @keyup.enter="submitForm('ruleForm')"
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-bottom: 15px" prop="captcha">
        <el-input
          v-model="ruleForm.captcha"
          placeholder="请输入图形验证码"
          class="reg-create-captcha-ipt"
          @keyup.enter="submitForm('ruleForm')"
        >
          <div
            slot="append"
            v-bind:style="{ background: captchaBg }"
            class="captcha-img"
            @click="refreshCaptcha"
          ></div>
        </el-input>
      </el-form-item>
      <div style="margin-bottom: 20px" class="flex">
        <div class="flex-1">
          <el-checkbox
            style="
              padding: 5px 0;
              font-size: 12px;
              color: #808080;
              line-height: 19px;
            "
            v-model="ruleForm.remember"
            >记住密码登录</el-checkbox
          >
        </div>
        <a @click="forget" style="line-height: 30px">忘记密码？</a>
      </div>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button
        @click="submitForm('ruleForm')"
        style="width: 100%"
        type="primary"
        round
        :loading="loginLoading"
        >登录</el-button
      >
    </div>
    <div>
      <el-button type="text" style="width: 100%;margin-bottom: 10px;" @click="regist"
        >立即注册</el-button
      >
    </div>
    <!-- 江西省可信身份认证系统登录按钮 -->
    <div style="margin-bottom: 10px">
      <el-button 
        style="width: 100%" 
        round
        @click="gotoProvinceAuthPage"
        type="warning"
        :loading="provinceLoginLoading"
      >
        江西省可信身份认证系统登录
      </el-button>
    </div>
    <!-- 注销按钮（登录后显示） -->
    <div v-if="isLogin" style="margin-bottom: 10px">
      <el-button 
        style="width: 100%" 
        round
        @click="logoutProvinceAuth"
        type="danger"
        :loading="logoutLoading"
      >
        退出统一身份认证登录
      </el-button>
    </div>

    <!-- 账号绑定弹窗 -->
    <el-dialog title="绑定业务系统账号" :visible.sync="isShowBindDialog" width="350px" :close-on-click-modal="false">
      <el-form :model="bindForm" :rules="bindRules" ref="bindForm" label-width="120px">
        <el-form-item label="业务系统手机号" prop="mobile">
          <el-input v-model="bindForm.mobile" placeholder="请输入已注册手机号"></el-input>
        </el-form-item>
        <el-form-item label="业务系统密码" prop="passwd">
          <el-input v-model="bindForm.passwd" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="isShowBindDialog = false">取消</el-button>
        <el-button type="primary" @click="submitBindForm()" :loading="bindLoading">确认绑定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.reg-create-captcha-ipt .el-input-group__append {
  padding: 0 !important;
  overflow: hidden;
}
.captcha-img {
  height: 38px;
  background-size: 100% 100% !important;
  width: 130px;
  cursor: pointer;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>

<script>
import store from '@/store'
import { getCaptCha } from "@/service/common";
import { getUser } from "@/service/blc";
import { initAccount } from '@/service/account';
import { phoneReg } from "@/utils";
import { Base64 } from "js-base64";
import { 
  loginByMobileAndPwd, 
  createMobileAccountAgo, 
  bindAccount, 
  trustPass, 
  logoutProvince,
  getProvinceToken,
  getUserMainInfo,
  getPersonUserDetail,
  getCorpUserDetail
} from "@/service/account";

// 省统一身份认证配置（授权文件参数）
const AUTH_BASE_URL = "https://sfrz.ganzhou.gov.cn:8090/boot";
const CLIENT_CONFIG = {
  clientId: "7s0MO4PquKXImbLWQ2VjHY6i",
  clientSecret: "4yGMN6K9AkuRcKUShWsmM8POh4NC7rbv",
  redirectUri: "http://ztvue.nk001.com/login"
};

export default {
  props: {},
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else {
        const reg = phoneReg;
        if (reg.test(value)) {
          createMobileAccountAgo({ mobile: value })
            .then((rst) => {
              if (rst.reg == 0) {
                return callback(new Error("该手机号尚未注册"));
              } else {
                callback();
              }
            })
            .catch((err) => {
              console.log(err);
              callback();
            });
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };

    return {
      ruleForm: {
        mobile: "",
        passwd: "",
        captcha: "",
        captchaToken: "",
        remember: false,
      },
      rules: {
        mobile: [{ validator: checkPhone, trigger: "blur" }],
        passwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        captcha: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
      },
      captchaBg: null,
      isLogin: false,
      loginLoading: false,
      provinceLoginLoading: false,
      logoutLoading: false,
      bindLoading: false,
      isShowBindDialog: false,
      // 绑定表单数据
      bindForm: {
        mobile: "",
        passwd: "",
        provinceUuid: ""
      },
      bindRules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        passwd: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      // 省平台登录地址（按规范2.1.2拼接）
      provinceLoginUrl: `${AUTH_BASE_URL}/admin/login/trust?response_type=code&client_id=${CLIENT_CONFIG.clientId}&redirect_uri=${encodeURIComponent(CLIENT_CONFIG.redirectUri)}`
    };
  },
  created() {},
  mounted() {
    // 快捷键登录
    let _self = this;
    this.$parent.$refs.frame.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13 || key == 100) {
        _self.submitForm("ruleForm");
      }
    };

    this.refreshCaptcha();
    this.isLogin = !!localStorage.getItem("business_token");

    // 解析省平台回调code（登录/信任传递，规范1.1.2）
    const authCode = this.getUrlParam("code");
    if (authCode) {
      window.history.replaceState({}, document.title, window.location.pathname);
      this.processAuthFlow(authCode);
    }
  },
  methods: {
    goto(path) {
      this.$router.push(path);
    },
    refreshCaptcha() {
      getCaptCha()
        .then((rsp) => {
          this.captchaBg = `url('data:image/svg+xml,${encodeURIComponent(rsp.svg)}') no-repeat center`;
          this.ruleForm.captchaToken = rsp.token;
        })
        .catch((err) => {
          this.$message.error(err.message || "图形验证码加载失败");
        });
    },
    submitForm(formName) {
      this.loginLoading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const remember = this.ruleForm.remember ? 1 : 0;
          loginByMobileAndPwd({ ...this.ruleForm, remember })
            .then((res) => {
              getUser({
                phoneOrOpenid: this.ruleForm.mobile,
                password: Base64.encode(this.ruleForm.passwd),
                orgId: res.comp?.id || 0,
                tenantId: 0,
              });
              localStorage.setItem("business_token", res.token);
              this.isLogin = true;
              this.$message.success("登录成功");
              this.$emit("success");
            })
            .catch((err) => {
              this.$message.error(err.message || "登录失败");
              this.refreshCaptcha();
            })
            .finally(() => {
              this.loginLoading = false;
            });
        } else {
          this.loginLoading = false;
          this.refreshCaptcha();
          console.log("表单验证失败");
          return false;
        }
      });
    },
    regist() {
      this.$emit("register");
    },
    forget() {
      this.$emit("onForget");
    },
    // 跳转省平台登录页（规范2.1）
    gotoProvinceAuthPage() {
      this.provinceLoginLoading = true;
      if (!CLIENT_CONFIG.clientId || !CLIENT_CONFIG.redirectUri) {
        this.$message.error("配置错误，无法跳转统一认证页面");
        this.provinceLoginLoading = false;
        return;
      }
      window.location.href = this.provinceLoginUrl;
    },
    // URL参数解析工具
    getUrlParam(paramName) {
      const search = window.location.search.slice(1);
      const paramMap = new URLSearchParams(search);
      return paramMap.get(paramName);
    },
    // 统一认证核心流程（code→token→用户信息→登录/绑定，规范1.1.4）
    async processAuthFlow(code) {
      try {
        this.provinceLoginLoading = true;
        this.$message.info("正在通过统一身份认证登录...");

        // 步骤1：code换token（规范2.2）
        
        const trustRes = await getProvinceToken(code);
        console.log("获取到的个人用户和法人主体信息:", trustRes);
        console.log("获取到的个人用户或法人主体信息详细数据:", trustRes.user);
        // 步骤2：获取用户主体信息（区分个人/法人，规范3.1）
        // const mainInfoRes = await getUserMainInfo(tokenRes.access_token);
        // console.log("获取到的mainInfoRes:", mainInfoRes);
        
        const { mobile } = trustRes;
        
        // console.log("获取到的用户类型:", userType);
        // if (!userType) throw new Error("获取用户类型失败");

        // // 步骤3：根据用户类型获取详细信息（规范3.2/3.3）
        // let userDetailInfo;
        // if (userType === "1") {
        //   // 个人用户
        //   userDetailInfo = await getPersonUserDetail();
        // } else if (userType === "2") {
        //   // 法人用户
        //   userDetailInfo = await getCorpUserDetail();
        // } else {
        //   throw new Error("不支持的用户类型");
        // }

        // 步骤4：检查绑定状态（信任传递接口，规范3.5）
        if (trustRes.needBind) {
          // 未绑定：显示绑定弹窗（规范1.1.3.2.3）
          this.isShowBindDialog = true;
          this.bindForm = {
            ...this.bindForm,
            provinceUuid: trustRes.provinceUser.uuid,
            mobile: mobile || ""
          };
        } else {
          // 已绑定：直接登录
          localStorage.setItem("business_token", trustRes.token);
          // await getUser({
          //   phoneOrOpenid: mobile ,
          //   orgId: trustRes.comp?.id || 0,
          //   tenantId: 0
          // });
          await initAccount(trustRes.token);
          this.isLogin = true;
          this.$message.success("统一身份认证登录成功");
          this.$emit("success");
    
        }
      } catch (err) {
        this.$message.error(`可信身份登录失败：${err.message || "系统异常"}`);
        this.refreshCaptcha();
      } finally {
        this.provinceLoginLoading = false;
      }
    },
    // 提交账号绑定（规范1.1.3.2.3）
    async submitBindForm() {
      this.bindLoading = true;
      this.$refs.bindForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await bindAccount({
              provinceUuid: this.bindForm.provinceUuid,
              mobile: this.bindForm.mobile,
              passwd: this.bindForm.passwd
            });

            // 绑定成功：存储token并登录
            localStorage.setItem("business_token", res.token);
            // await getUser({
            //   phoneOrOpenid: res.user.mobile,
            //   orgId: res.comp?.id || 0,
            //   tenantId: 0
            // });
            this.isShowBindDialog = false;
            this.isLogin = true;
            this.$message.success("账号绑定成功，已自动登录");
            this.$emit("success");
          } catch (err) {
            this.$message.error(`绑定失败：${err.message || "绑定异常"}`);
          } finally {
            this.bindLoading = false;
          }
        } else {
          this.bindLoading = false;
          return false;
        }
      });
    },
    // 统一身份认证注销（规范3.6）
    async logoutProvinceAuth() {
      this.logoutLoading = true;
      try {
        const user = store.state.loginUser?.user;
        if (!user?.id) throw new Error("未获取到登录用户信息");

        const res = await logoutProvince({ user_id: user.id });
        // 清理本地状态 + 跳转省平台注销地址
        localStorage.removeItem("business_token");
        this.isLogin = false;
        window.location.href = res.logoutUrl;
        this.$emit("logout");
      } catch (err) {
        this.$message.error(`注销失败：${err.message || "注销异常"}`);
        this.logoutLoading = false;
      }
    }
  },
};
</script>